import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import assetColors, { AssetColor } from '../../assets/assetColors';
import { CategoryID } from '../types/PartsCategory';
import ScrollViewWithFadeIndicators from './ScrollViewWithFadeIndicators';
import { VerticalSpacer10 } from './Spacers';
import Subtitle from './Subtitle';

type Props = {
  selectedCategoryID: CategoryID;
  selectedColor: AssetColor;
  onColorSelected: (assetColor: AssetColor) => void;
};

export default ({
  selectedCategoryID,
  selectedColor,
  onColorSelected,
}: Props) => {
  return (
    <View>
      {assetColors[selectedCategoryID] && (
        <>
          <VerticalSpacer10 />
          <Subtitle>Choose a color</Subtitle>
          <View style={{ height: 8 }} />
          <ScrollViewWithFadeIndicators>
            {assetColors[selectedCategoryID]?.map((assetColor) => (
              <TouchableOpacity
                onPress={() => onColorSelected(assetColor)}
                key={assetColor[0]}
              >
                <View
                  style={[
                    styles.color,
                    { backgroundColor: assetColor[0] },
                    selectedColor[0] === assetColor[0]
                      ? { borderColor: 'white' }
                      : {},
                  ]}
                />
              </TouchableOpacity>
            ))}
          </ScrollViewWithFadeIndicators>
        </>
      )}
    </View>
  );
};

const SIZE = 36;

const styles = StyleSheet.create({
  color: {
    width: SIZE,
    aspectRatio: 1,
    borderRadius: SIZE / 2,
    margin: 3,
    borderWidth: 3,
    borderColor: 'transparent',
  },
});
